// TimeframeSelector — 15m · 1h · 4h · 1d
import React from "react";

const TFS = ["15m", "1h", "4h", "1d"];

export default function TimeframeSelector({ value, onChange }) {
  return (
    <div className="flex gap-1" data-testid="liqmap-tf-selector">
      {TFS.map((tf) => {
        const active = value === tf;
        return (
          <button
            key={tf}
            onClick={() => onChange(tf)}
            data-testid={`liqmap-tf-${tf}`}
            className={
              "rounded-md px-2.5 py-1 font-mono text-[10px] font-bold transition-all " +
              (active
                ? "bg-[#f97316] text-black"
                : "border border-white/10 bg-white/[0.03] text-white/50 hover:border-[#f97316]/40 hover:text-white")
            }
          >
            {tf}
          </button>
        );
      })}
    </div>
  );
}
